export default {
  settings: {
    title: "Data export",
    intro:
      "Request a complete copy of everything your company has put into Lewara: projects, [[cr.pl]], [[hwr.pl]], master data and every uploaded document. You receive a ZIP archive containing machine-readable JSON files, the familiar CSV tables and your file storage.",
    request: "Request export",
    requesting: "Requesting ...",
    queued_hint:
      "The archive is built in the background and may take a few minutes depending on how much data there is. You can leave this page.",
    empty: "You have not requested an export yet.",
    table: {
      requested: "Requested",
      status: "Status",
      size: "Size",
      contents: "Contents",
      available_until: "Available until",
      action: "Archive",
    },
    status: {
      QUEUED: "Queued",
      RUNNING: "Building",
      READY: "Ready",
      FAILED: "Failed",
      EXPIRED: "Expired",
    },
    contents: "{documents} records, {files} files",
    download: "Download",
    expired_hint: "The archive was deleted after its retention period. Request a new one if you need it.",
    already_pending: "An export is already being built. Please wait until it has finished.",
    load_failed: "The list of exports could not be loaded.",
    request_failed: "The export could not be requested.",
    download_failed: "The archive could not be downloaded.",
  },
}
